<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#fbae31'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="content" v-if="!loading">
      <img :src="icon" id="icon" />
      <div class="text1">
        {{ this.$store.getters.TRANSLATIONS["why_park_yourself"] }}, <br />{{
          this.$store.getters.TRANSLATIONS["when_you_can"]
        }}
        <br />{{ this.$store.getters.TRANSLATIONS["parkenda"] }}
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="login()" class="button login_button">
        {{ this.$store.getters.TRANSLATIONS["login"] }}
      </button>
      <button v-on:click="signUp()" class="button signup_button">
        {{ this.$store.getters.TRANSLATIONS["signup"] }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    if (this.$storage.get("parkendaToken")) {
      const timeout = setTimeout(() => {
        this.loading = true;
      }, 0);
      this.$http
        .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
          headers: {
            "x-access-token": this.$storage.get("parkendaToken")
          }
        })
        .then((response) => {
          this.$store.dispatch("SAVE_USER", response.data);
          this.$store.dispatch(
            "SAVE_TOKEN",
            this.$storage.get("parkendaToken")
          );
          // console.log("---------------------------------------------------");
          // this.$store.dispatch("SET_LANGUAGE", response.data.language);
          // this.$store.dispatch(
          //   "SET_TRANSLATIONS",
          //   require(`../assets/i18n/${this.$store.getters.SELECTED_LANGUAGE}.json`)
          // );
          // this.$router.go();
        })
        .then(() => {
          return this.$http
            .get(`${process.env.SERVER_URL}/FA04C1C44AFA43CF9170E1D70335412B`, {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            })

            .then((response) => {
              console.log("Have active parking response");
              console.log(response);
              if (response.data && response.data.haveActiveParking) {
                this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", true);
                this.$router.push("/currentParking");
              } else {
                this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", false);
                this.$router.push("/parkendaValet");
              }
            });
        })
        .catch((e) => {
          this.$storage.remove("parkendaToken");
        })
        .finally(() => {
          clearTimeout(timeout);
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  },
  data() {
    return {
      loading: true,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      icon: require("@/assets/new_design/Parkenda_VerticalLogo_FullColour.png"),
      signUp: () => {
        this.$router.push("/signUp");
      },
      login: () => {
        this.$router.push("/login");
      }
    };
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
.loading {
  margin: auto;
}
#icon {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 12vh;
  height: 40vw;
}
.text1 {
  color: #f7f7f7;
  font-size: 11px;
  font-family: BrandonGrotesqueMedium;
  text-align: center;
  margin-top: 15px;
}
.signup_button {
  background-color: white;
  color: #fbae31;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue